import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SupervisorService } from '../supervisor.service';
import { SupervisorDashboardDto } from '../models/supervisor.model';

@Injectable()
export class SupervisorApiService extends SupervisorService {
  private readonly http = inject(HttpClient);
  getDashboard(): Observable<SupervisorDashboardDto> {
    return this.http.get<SupervisorDashboardDto>(`${environment.apiBaseUrl}/api/v1/supervision/dashboard`).pipe(map(mapDashboard));
  }
  override reassignCase(caseId: string, agentId: string, reason?: string): Observable<void> {
    return this.http.post<void>(`${environment.apiBaseUrl}/api/v1/cases/${encodeURIComponent(caseId)}/reassign`, { agentId, reason });
  }
}

function mapDashboard(value: SupervisorDashboardDto): SupervisorDashboardDto {
  return { ...value, kpis: value.kpis ?? ({} as SupervisorDashboardDto['kpis']), portfolioByAging: value.portfolioByAging ?? [], teamPerformance: value.teamPerformance ?? [], priorityAlerts: value.priorityAlerts ?? [] };
}
